@use '../../styles/global' as *;
@use '../../styles/kol-alert-mixin' as *;
@use '../@shared/kol-button-mixin' as *;
@use '../@shared/kol-popover-button-mixin' as *;
@use '../@shared/kol-table-stateless-mixin' as *;
@use '../@shared/mixins' as *;
@use '../host-display-block' as *;
@use '../tooltip/style' as *;

@layer kol-component {
	@include kol-alert;
	@include kol-button-styles('kol-button');
	@include kol-popover-button-styles;
	@include kol-table-stateless-styles;
}
